import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Chart } from 'chart.js/auto';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { Subscription } from 'rxjs';
import { UserService } from 'src/app/services/user.service';
import { Router } from '@angular/router';
import { Error429Service } from 'src/app/services/error429.service';
interface Clientes{
  value: number;
  name: string;
}
interface Usuarios{
  value: number;
  name: string;
}
@Component({
  selector: 'app-estadisticas',
  templateUrl: './estadisticas.component.html',
  styleUrls: ['./estadisticas.component.css']
})
export class EstadisticasComponent implements OnInit{

  fechaActual: Date = new Date();
  dia: number = this.fechaActual.getDate(); 
  mes: number = this.fechaActual.getMonth(); 
  anio: number = this.fechaActual.getFullYear(); 
  mes1 = this.mes + 1;

  selectedDateGlobal = new FormGroup({
    start: new FormControl(new Date(this.anio, this.mes, this.dia)),
    end: new FormControl(new Date(this.anio, this.mes, this.dia)),
    //start: new FormControl(),
    //end: new FormControl(),
  });
  startGlobal: string = "";
  endGlobal: string = "";

  selectedDateCliente = new FormGroup({
    start: new FormControl(new Date(this.anio, this.mes, this.dia)),
    end: new FormControl(new Date(this.anio, this.mes, this.dia)),
  });
  startCliente: string = "";
  endCliente: string = "";

  selectedDateUsuario = new FormGroup({
    start: new FormControl(new Date(this.anio, this.mes, this.dia)),
    end: new FormControl(new Date(this.anio, this.mes, this.dia)),
  });
  startUsuario: string = "";
  endUsuario: string = "";

  //Clientes
  clientes: Clientes[] = [
  ];
  selectedClienteUsuario: number | undefined;
  selectedClienteCliente: number | undefined;

  //Usuarios
  usuarios: Usuarios[] = [
  ];
  selectedUsuario: number | undefined;

  opcionSeleccionada: string = "global";
  admin: boolean = true;
  usuariosActivos: boolean = true;
  sesionesTotales: boolean = false;
  charts: Chart[] = [];
  clientsData: any = []; //Información de los clientes
  errorMessage: string = "";
  tiempoEsperaRecarga: number = 60000;
  usersData: any = [];

  //selectedDateGlobal: FormGroup;

  private clientsSubscription: Subscription | undefined;
  private usersSubscription: Subscription | undefined;

  constructor(private dateAdapter: DateAdapter<Date>, private userService: UserService, private router: Router,
    private error429: Error429Service){
    this.dateAdapter.setLocale('es-ES'); // Configurar el idioma a españolfechaActual
  }

  ngOnInit(): void {
    if(this.usuariosActivos){
      this.loadChartUsuarios();
    }
    if(this.sesionesTotales){
      this.loadChartSesiones();
    }
    //Conseguir datos de clientes
    this.clientsSubscription = this.userService.getClients().subscribe({
      next:resp =>{
        for(let i=0; i<resp.length; i++){
          this.clientsData.push(resp[i]);
          this.clientes.push({
            value: resp[i].id,
            name: resp[i].razon_social
          });
        }
      },error:err =>{
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      }, complete:()=>{}
    });
    //Conseguir datos de los Usarios
      this.usersSubscription = this.userService.getUsers().subscribe({
        next:resp =>{
          for(let i=0; i<resp.length; i++){
            this.usersData.push(resp[i]);
            this.usuarios.push({
              value: resp[i].id,
              name: resp[i].email,
            });
          }
        },error:err =>{
          if (err.status == 429) {
            this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
            this.recargarPaginaDespuesDeTiempo();
          } else {
            this.errorMessage = err.error.message;
          }
        }, complete:()=>{}
      });
  }

  ngOnDestroy(): void {
    if (this.usersSubscription) {
      this.usersSubscription.unsubscribe();
    } 
    if (this.clientsSubscription) {
      this.clientsSubscription.unsubscribe();
    } 
  }

  recargarPaginaDespuesDeTiempo() {
    this.error429.setError(true);
    window.location.reload();
  }

  onTabFocusChange(event: any) {
    if (event.tab.textLabel === 'Usuarios activos') {
      this.usuariosActivos = true;
      this.sesionesTotales = false;
      this.loadChartUsuarios();
    }
    if (event.tab.textLabel === 'Sesiones totales') {
      this.usuariosActivos = false;
      this.sesionesTotales = true;
      this.loadChartSesiones();
    }
  }

  convertirFechaInicio(selectedDate: FormGroup): string {
    if (selectedDate.value.start) {
      const fecha = new Date(selectedDate.value.start);
      const year = fecha.getFullYear();
      const month = (fecha.getMonth() + 1).toString().padStart(2, '0');
      const day = fecha.getDate().toString().padStart(2, '0');
      const fechaFormateada = `${day}-${month}-${year}`;
      return fechaFormateada;
    }
    return "Fecha Inicio no seleccionada";
  }

  convertirFechaFin(selectedDate: FormGroup): string {
    if (selectedDate.value.end) {
      const fecha = new Date(selectedDate.value.end);
      const year = fecha.getFullYear();
      const month = (fecha.getMonth() + 1).toString().padStart(2, '0');
      const day = fecha.getDate().toString().padStart(2, '0');
      const fechaFormateada = `${day}-${month}-${year}`;
      return fechaFormateada;
    }
    return "Fecha Fin no seleccionada";
  }

  destroyCharts() {
    Object.values(this.charts).forEach((chart) => {
      chart.destroy();
    });
    this.charts = [];
  }

  loadChartUsuarios() {
    this.destroyCharts();
    setTimeout(() => {
      const canvasU: any = document.getElementById('usuarios');
      const ctxU = canvasU.getContext('2d');

      let startElegido: string = "";
      let endElegido: string = "";
      switch (this.opcionSeleccionada){
        case "global":
          startElegido = this.convertirFechaInicio(this.selectedDateGlobal);
          endElegido = this.convertirFechaFin(this.selectedDateGlobal);
          break;
        case "cliente":
          startElegido = this.convertirFechaInicio(this.selectedDateCliente);
          endElegido = this.convertirFechaFin(this.selectedDateCliente);
          break;
        case "usuario":
          startElegido = this.convertirFechaInicio(this.selectedDateUsuario);
          endElegido = this.convertirFechaFin(this.selectedDateUsuario);
          break;
      }

      let usuariosActivos: number[] = [3, 1];
      let datasetsUsuarios = [];
      datasetsUsuarios.push({
        label: 'Usuarios',
        data: usuariosActivos,
        borderWidth: 1,
        backgroundColor: 'rgba(175,45,216,0.1)',
        borderColor: 'rgba(175,45,216,1)',
        pointBackgroundColor: 'rgba(175,45,216,1)',
        pointBorderWidth: 10,
        pointHoverRadius: 10,
        pointHoverBorderWidth: 1,
        pointRadius: 0,
        fill: true,
      });

      let timeLabelsUsuarios: string[] = [startElegido, endElegido];
      // Gráfico Usuarios
      const chartU = new Chart(ctxU, {
        type: 'line',
        data: {
          labels: timeLabelsUsuarios,
          datasets: datasetsUsuarios
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          animation: {
            easing: "easeInOutBack"
          },
          plugins: {
            legend: {
              position: "top",
              labels: {
                boxWidth: 20,
                font: {
                  size: 10
                }
              }
            }
          },
          interaction: {
            mode: 'index',
            intersect: false,
          },
          scales: {
            y: {
              beginAtZero: true,
              position: 'left',
              ticks: {
                color: "rgba(0,0,0,0.5)",
                font: {
                  size: 10,
                  weight: 'bold'
                },
                padding: 3
              },
              grid: {
                display: false
              }
            },
            x: {
              ticks: {
                padding: 5,
                color: "rgba(0,0,0,0.5)",
                font: {
                  size: 10,
                  weight: 'bold'
                },
                //autoSkip: false, ->Mostrar todo el contenido de las labels en el eje x
              },
              grid: {
                display: false
              }
            }
          }
        }
      });
      this.charts.push(chartU);
    },0)
  }

  loadChartSesiones() {
    this.destroyCharts();
    setTimeout(() => {
      const canvasS: any = document.getElementById('sesiones');
      const ctxS = canvasS.getContext('2d');

      let startElegido: string = "";
      let endElegido: string = "";
      switch (this.opcionSeleccionada){
        case "global":
          startElegido = this.convertirFechaInicio(this.selectedDateGlobal);
          endElegido = this.convertirFechaFin(this.selectedDateGlobal);
          break;
        case "cliente":
          startElegido = this.convertirFechaInicio(this.selectedDateCliente);
          endElegido = this.convertirFechaFin(this.selectedDateCliente);
          break;
        case "usuario":
          startElegido = this.convertirFechaInicio(this.selectedDateUsuario);
          endElegido = this.convertirFechaFin(this.selectedDateUsuario);
          break;
      }

      let sesionesTotales: number[] = [4, 10];
      let datasetsSesiones = [];
      datasetsSesiones.push({
        label: 'Sesiones',
        data: sesionesTotales,
        borderWidth: 1,
        backgroundColor: 'rgba(83,55,262,0.1)',
        borderColor: 'rgba(83,55,262,1)',
        pointBackgroundColor: 'rgba(83,55,262,1)',
        pointBorderWidth: 10,
        pointHoverRadius: 10,
        pointHoverBorderWidth: 1,
        pointRadius: 0,
        fill: true,
      });

      let timeLabelsUsuarios: string[] = [startElegido, endElegido];
      // Gráfico Sesiones
      const chartS = new Chart(ctxS, {
        type: 'line',
        data: {
          labels: timeLabelsUsuarios,
          datasets: datasetsSesiones
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          animation: {
            easing: "easeInOutBack"
          },
          plugins: {
            legend: {
              position: "top",
              labels: {
                boxWidth: 20,
                font: {
                  size: 10
                }
              }
            }
          },
          interaction: {
            mode: 'index',
            intersect: false,
          },
          scales: {
            y: {
              beginAtZero: true,
              position: 'left',
              ticks: {
                color: "rgba(0,0,0,0.5)",
                font: {
                  size: 10,
                  weight: 'bold'
                },
                padding: 3
              },
              grid: {
                display: false
              }
            },
            x: {
              ticks: {
                padding: 5,
                color: "rgba(0,0,0,0.5)",
                font: {
                  size: 10,
                  weight: 'bold'
                },
                //autoSkip: false, ->Mostrar todo el contenido de las labels en el eje x
              },
              grid: {
                display: false
              }
            }
          }
        }
      });
      this.charts.push(chartS);
    },0)
  }

  //Actualizar los valores de las gráficas
  loadCharts() {
    this.destroyCharts();
    let startElegido: string = "";
    let endElegido: string = "";
    switch (this.opcionSeleccionada){
      case "global":
        startElegido = this.convertirFechaInicio(this.selectedDateGlobal);
        endElegido = this.convertirFechaFin(this.selectedDateGlobal);
        break;
      case "cliente":
        startElegido = this.convertirFechaInicio(this.selectedDateCliente);
        endElegido = this.convertirFechaFin(this.selectedDateCliente);
        break;
      case "usuario":
        startElegido = this.convertirFechaInicio(this.selectedDateUsuario);
        endElegido = this.convertirFechaFin(this.selectedDateUsuario);
        break;
    }

    if(this.usuariosActivos){
      this.loadChartUsuarios();
    }
    if(this.sesionesTotales){
      this.loadChartSesiones();
    }

    console.log("Start elegido: ", startElegido);
    console.log("End elegido: ", endElegido);

    console.log("Usuarios activos es: ", this.usuariosActivos);
    console.log("Sesiones totales es: ", this.sesionesTotales);

    console.log("La opción seleccionada es: ",this.opcionSeleccionada);

    console.log("La opción de incluir administradores es: ",this.admin);
    console.log("Cliente elegido (estadisicas cliente): ", this.selectedClienteCliente);
    console.log("Cliente elegido (estadisicas usuario): ", this.selectedClienteUsuario);
    console.log("Usuario elegido (estadisicas usuario): ", this.selectedUsuario);
    
    //Conseguir las fechas
    this.startGlobal = this.convertirFechaInicio(this.selectedDateGlobal);
    this.endGlobal = this.convertirFechaFin(this.selectedDateGlobal);
    console.log("La fecha seleccionada de inicio en global es: ", this.startGlobal);
    console.log("La fecha seleccionada de fin en global es: ", this.endGlobal);

    this.startCliente = this.convertirFechaInicio(this.selectedDateCliente);
    this.endCliente = this.convertirFechaFin(this.selectedDateCliente);
    console.log("La fecha seleccionada de inicio en cliente es: ", this.startCliente);
    console.log("La fecha seleccionada de fin en cliente es: ", this.endCliente);

    this.startUsuario = this.convertirFechaInicio(this.selectedDateUsuario);
    this.endUsuario = this.convertirFechaFin(this.selectedDateUsuario);
    console.log("La fecha seleccionada de inicio en usuario es: ", this.startUsuario);
    console.log("La fecha seleccionada de fin en usuario es: ", this.endUsuario);

    console.log("---------------------------");
  }

}
